@if (language$ | async; as language) {
  @if (subCategories$ | async; as subCategories) {
    <!-- Desktop -->
    <div class="subcategory-filter d-none d-lg-block pt-4">
      @if (activeMainCategory$ | async; as activeMainCategory) {
        <div class="ms-4">
          <span>{{ 'MoreRelevantArticles' | translate }}</span>
          <h2 class="h3 text-brand" wlAutomationId="current-category">
            {{ activeMainCategory.name }}
          </h2>
        </div>
      }
      <nav class="nav flex-column">
        @for (menuItem of subCategories$ | async; track menuItem) {
          <a
            [routerLink]="getRouteUrl(menuItem, language)"
            [class.active]="menuItem.active"
            class="subcategory-filter__link nav-link d-flex align-items-center fw-bold px-0"
          >
            <span
              class="subcategory-filter__link-bullet d-inline-flex me-2"
            ></span>
            <span class="d-inline-flex">{{ menuItem.name }}</span>
          </a>
        }
      </nav>
    </div>

    <!-- Mobile -->
    @if (subCategories.length > 0) {
      <div class="d-lg-none pb-2 pt-sm-2">
        <select
          class="form-select form-select-sm"
          role="navigation"
          [ngModel]="activeSubcategory$ | async"
          (ngModelChange)="onChange($event, language)"
        >
          <option disabled [ngValue]="null">
            {{ 'MoreRelevantArticles' | translate }}
          </option>
          @for (menuItem of subCategories$ | async; track menuItem) {
            <option [ngValue]="menuItem">
              {{ menuItem.name }}
            </option>
          }
        </select>
      </div>
    }
  }
}
